import React from 'react';
import { FormattedMessage, FormattedNumber, FormattedTime, FormattedDate } from 'react-intl';
export var UI_LISTS_NAMESPACE = 'ui-lists';
/** Translate a given translation ID, returning a JSX element */
export var t = function (id, values) {
    var idWithPrefix = "".concat(UI_LISTS_NAMESPACE, ".").concat(id);
    return React.createElement(FormattedMessage, { id: idWithPrefix, values: values });
};
/**
 * Translate a given translation ID, returning a string
 *
 * @param intl should come from useIntl() in the calling code
 */
export var tString = function (intl, id, values) {
    var idWithPrefix = "".concat(UI_LISTS_NAMESPACE, ".").concat(id);
    return intl.formatMessage({ id: idWithPrefix }, values);
};
export var formatNumber = function (number) {
    if (number === void 0) { number = 0; }
    return React.createElement(FormattedNumber, { value: Number(number) });
};
export var formatTime = function (date) {
    return React.createElement(FormattedTime, { value: date });
};
export var formatDate = function (date) {
    return React.createElement(FormattedDate, { value: date });
};
